import { X } from 'lucide-react';
import { StatusFilter, TEMPLATE_STATUS_LABEL, type TemplateListStatus } from '../types';
import styles from './templates-toolbar.module.css';

interface ActiveFilterChipsProps {
  statusFilter: StatusFilter;
  clearStatus: () => void;
  selectedTenantIds: string[];
  tenantNameById: Map<string, string>;
  removeTenant: (tenantId: string) => void;
  clearAll: () => void;
}

export function ActiveFilterChips({
  statusFilter,
  clearStatus,
  selectedTenantIds,
  tenantNameById,
  removeTenant,
  clearAll,
}: ActiveFilterChipsProps) {
  const activeStatus: TemplateListStatus | null =
    statusFilter === StatusFilter.All ? null : statusFilter;

  return (
    <div className={styles.chips}>
      <span className={styles.chipsLabel}>Filtering by</span>
      {activeStatus && (
        <span className={styles.chip} data-tone="status">
          {TEMPLATE_STATUS_LABEL[activeStatus]}
          <button
            type="button"
            className={styles.chipRemove}
            onClick={clearStatus}
            aria-label="Clear status filter">
            <X className={styles.chipRemoveIcon} />
          </button>
        </span>
      )}
      {selectedTenantIds.map(tenantId => {
        const tenantName = tenantNameById.get(tenantId) ?? tenantId;
        return (
          <span key={tenantId} className={styles.chip} data-tone="status">
            {tenantName}
            <button
              type="button"
              className={styles.chipRemove}
              onClick={() => removeTenant(tenantId)}
              aria-label={`Remove ${tenantName} filter`}>
              <X className={styles.chipRemoveIcon} />
            </button>
          </span>
        );
      })}
      <button type="button" className={styles.clearAll} onClick={clearAll}>
        Clear all
      </button>
    </div>
  );
}
